import SearchForm from '../../model/search-form';

export default class OrderSearchForm implements SearchForm {

  private readonly dateFrom: JQuery;
  private readonly dateUntil: JQuery;
  private readonly submitButton: JQuery;
  private readonly onlyWithDeliveryDate: JQuery;
  private readonly materialNumber: JQuery;
  private readonly orderId: JQuery;
  private readonly externalId: JQuery;

  constructor(private form: JQuery<HTMLFormElement>) {
    this.dateFrom = this.form.find('.js-dateFrom');
    this.dateUntil = this.form.find('.js-dateUntil');
    this.submitButton = this.form.find('.js-submit');
    this.onlyWithDeliveryDate = this.form.find('.js-onlyWithDeliveryDate');
    this.materialNumber = this.form.find('.js-materialNumber');
    this.orderId = this.form.find('.js-orderId');
    this.externalId = this.form.find('.js-externalId');

    this.prepareForm();
    this.bindValidateForm();
  }

  private bindValidateForm(): void {
    this.form.on('change', (): void => {
      this.prepareForm();
    });
  }

  private prepareForm(): void {
    const dateFrom = this.dateFrom.datepicker('getDate');
    if (dateFrom) {
      this.dateUntil.datepicker('option', { minDate: dateFrom });
    }
    this.submitButton.prop('disabled', !this.isFormValid());
  }

  getForm(): JQuery<HTMLFormElement> {
    return this.form;
  }

  submit(): void {
    this.form.submit();
  }

  private isFormValid(): boolean {
    if (this.missingUntilDate()) {
      return false;
    }

    if (!this.datesHaveValue() && this.allInputsEmpty()) {
      return false;
    }

    return true;
  }

  private allInputsEmpty(): boolean {
    // eslint-disable-next-line eqeqeq
    return this.orderId.val() == '' && this.externalId.val() == '' && this.materialNumber.val() == '' && !this.onlyWithDeliveryDate.is(':checked');
  }

  private datesHaveValue(): boolean {
    return this.dateFrom.val() !== '' && this.dateUntil.val() !== '';
  }

  private missingUntilDate(): boolean {
    // eslint-disable-next-line eqeqeq
    return this.dateFrom.val() !== '' && this.dateUntil.val() == '';
  }
}
